import {Theme} from '@material-ui/core';

const styles = (theme: Theme) => {
    return {
        root: {
            "& > *": {
                margin: theme.spacing(2, 0, 1, 0),
            },
        },
    }
}

export default styles;
